import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { CheckCheck, ChevronUp, Crown, Goal, X } from "lucide-react";
import { SubscriptionPlan } from "models/subscription/subcription-plan";
import { RoutePath } from "routes/route-path";
import { AppUtility } from "utility/app-utility";

interface Props {
  subscription?: SubscriptionPlan;
}

const SubscriptionCard: React.FC<Props> = ({ subscription }) => {
  const title = "Subscription";
  const pageTitle = "List";
  const navigate = useNavigate();
  const discountedValue: number = AppUtility.round2Decimal(
    (subscription?.discountAmount ?? 0) > 0
      ? subscription?.isDiscountAmount
        ? (subscription?.subcriptionValue ?? 0) - (subscription.discountAmount ?? 0)
        : (subscription?.subcriptionValue ?? 0) * ((100 - (subscription?.discountAmount ?? 0)) / 100)
      : subscription?.subcriptionValue ?? 0
  );

  const handleClick = () => {
    navigate(`${RoutePath.Admin_Subscription_manage.replace(":id", subscription?.id ?? "")}`);
  };

  return (
    <React.Fragment>
      <div className="test">
        <div className="relative overflow-hidden card !shadow-lg text-15">
          <div className="card-body">
            <div className="absolute top-0 size-16 ltr:right-0 rtl:left-0">
              {(subscription?.discountAmount ?? 0) > 0 && (
                <div className="absolute transform ltr:rotate-45 rtl:-rotate-45 bg-sky-500 text-center text-white font-medium py-1 ltr:-right-12 rtl:-left-12 top-6 w-[170px]">
                  {subscription?.discountAmount ?? 0}% Sale
                </div>
              )}
            </div>
            <h5 className="mb-2">
              <Goal className="inline-block size-5 text-green-500 ltr:mr-1 rtl:ml-1" />
              {/* <Crown className="inline-block size-5 ltr:mr-1 rtl:ml-1 text-sky-500" /> */}
              <span className="align-middle">{subscription?.displayName}</span>
            </h5>
            <p className="mb-4 text-slate-500 dark:text-zink-200">{subscription?.description}</p>
            {(subscription?.validNoOfDays ?? 0) > 0 ? (
              <>
                <p className="mb-4 text-slate-500 dark:text-zink-200">Valid: {subscription?.validNoOfDays} Days</p>
              </>
            ) : (
              <>
                <p className="mb-4 text-slate-500 dark:text-zink-200">
                  Valid From {AppUtility.ISOStringToDateOnlyString(subscription?.startDate ?? "")} To{" "}
                  {AppUtility.ISOStringToDateOnlyString(subscription?.endDate ?? "")}
                </p>
              </>
            )}

            {(subscription?.discountAmount ?? 0) > 0 ? (
              <>
                <h3 className="mb-4 font-normal" style={{ color: "GrayText", textAlign: "center" }}>
                  <span style={{ textDecoration: " line-through" }}>
                    <span className="text-slate-400 dark:text-zink-200">LKR</span>
                    <span className="text-red-200 dark:text-zink-200"> {subscription?.subcriptionValue}</span>
                  </span>
                  <small className="text-15 text-slate-500 dark:text-zink-200">/Yearly</small>
                </h3>
                <h1 className="mb-4 font-normal">
                  <span className="text-slate-400 dark:text-zink-200">LKR</span>
                  <span className="text-green-500 dark:text-zink-200">{discountedValue}</span>

                  <small className="text-15 text-slate-500 dark:text-zink-200">/Yearly</small>
                </h1>
              </>
            ) : (
              <>
                <h3 className="mb-4 font-normal" style={{ textDecoration: " line-through", color: "GrayText" }}>
                  <span className="text-slate-400 dark:text-zink-200">
                    <br></br>
                  </span>
                  <span className="text-red-200 dark:text-zink-200"> </span>
                </h3>
                <h1 className="mb-4 font-normal">
                  <span className="text-slate-400 dark:text-zink-200">LKR</span>
                  {subscription?.subcriptionValue}
                  <small className="text-15 text-slate-500 dark:text-zink-200">/Yearly</small>
                </h1>
              </>
            )}
            <button
              type="button"
              className="w-full bg-white border-dashed text-custom-500 btn border-custom-500 hover:text-custom-500 hover:bg-custom-50 hover:border-custom-600 focus:text-custom-600 focus:bg-custom-50 focus:border-custom-600 active:text-custom-600 active:bg-custom-50 active:border-custom-600 dark:bg-zink-700 dark:ring-custom-400/20 dark:hover:bg-custom-800/20 dark:focus:bg-custom-800/20 dark:active:bg-custom-800/20"
            >
              Purchase Now
            </button>
            <ul className="flex flex-col gap-3 mt-5">
              {(subscription?.features ?? []).map((ft, index) => (
                <div key={`ft-${index}`}>
                  {ft.enabled ?? false ? (
                    <li className="flex items-center gap-2">
                      <CheckCheck className="inline-block size-4 text-green-500 fill-green-100 dark:fill-green-500/20"></CheckCheck>
                      <span>{ft.feature?.name ?? ""}</span>
                    </li>
                  ) : (
                    <li className="flex items-center gap-2 line-through text-slate-500 dark:text-zink-200">
                      <X className="inline-block size-4 text-red-500 fill-green-100"></X>
                      <span> {ft.feature?.name ?? ""}</span>
                    </li>
                  )}
                </div>
              ))}

              {/* <li className="flex items-center gap-2">
                <CheckCheck className="inline-block size-4 text-green-500 fill-green-100 dark:fill-green-500/20"></CheckCheck>
                <span>
                  <b>299</b> Customers
                </span>
              </li>
              <li className="flex items-center gap-2">
                <CheckCheck className="inline-block size-4 text-green-500 fill-green-100 dark:fill-green-500/20"></CheckCheck>
                <span>Scalable Bandwidth</span>
              </li>
              <li className="flex items-center gap-2">
                <CheckCheck className="inline-block size-4 text-green-500 fill-green-100 dark:fill-green-500/20"></CheckCheck>
                <span>
                  <b>3</b> No Team Account
                </span>
              </li>
              <li className="flex items-center gap-2">
                <CheckCheck className="inline-block size-4 text-green-500 fill-green-100 dark:fill-green-500/20"></CheckCheck>
                <span>In app messaging</span>
              </li>
              <li className="flex items-center gap-2">
                <CheckCheck className="inline-block size-4 text-green-500 fill-green-100 dark:fill-green-500/20"></CheckCheck>
                <span>
                  <b>5</b> FTP Login
                </span>
              </li>
              <li className="flex items-center gap-2">
                <CheckCheck className="inline-block size-4 text-green-500 fill-green-100 dark:fill-green-500/20"></CheckCheck>
                <span>Detailed Analytics</span>
              </li>
              <li className="flex items-center gap-2 line-through text-slate-500 dark:text-zink-200">
                <X className="inline-block size-4 text-red-500 fill-green-100"></X>
                <span>Custom Domain</span>
              </li>
              <li className="flex items-center gap-2 line-through text-slate-500 dark:text-zink-200">
                <X className="inline-block size-4 text-red-500 fill-green-100"></X>
                <span>Smart Workflow</span>
              </li>
              <li className="flex items-center gap-2 line-through text-slate-500 dark:text-zink-200">
                <X className="inline-block size-4 text-red-500 fill-green-100"></X>
                <span>IQ test</span>
              </li> */}
            </ul>
          </div>
          <div className="flex justify-center gap-2 mt-4 mb-4">
            <button
              type="button"
              onClick={handleClick}
              className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            >
              Edit
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SubscriptionCard;
